import { render, staticRenderFns } from "./SharedChip.vue?vue&type=template&id=3f5fd9ee"
import script from "./SharedChip.vue?vue&type=script&lang=js"
export * from "./SharedChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports